import CotizarFormulario from './cotizarFormulario';
import CotizarResumen from './cotizarResumen';
import Mensajes from './mensajes';
import FormularioEntrada from './formularioEntrada';

export default class Cotizar extends React.Component {
  constructor() {
    super();
    this.state = {
      form: {
        lessthan60: { value: 0 },
        morethan60: { value: 0 },
        name: { value: '' },
        email: { value: '' },
        identificationType: { value: 'Seleccione un documento' },
        identificationNumber: { value: '' },
        phone: { value: '' },
        caja: { value: true },
        cajaCategory: { value: '' },
        eps: { value: true },
        includeMe: { value: false },
        isValid: true
      },
      temporaryForm: {},
      subscribed: {
        lessthan60: [],
        morethan60: []
      },
      summary: {
        monthlyFare: 0,
        epsDiscount: 0,
        cajaDiscount: 0,
        iva: 0,
        lessthan60quantity: 0,
        lessthan60total: 0,
        morethan60quantity: 0,
        morethan60total: 0,
        totalQuantity: 0,
        total: 0
      },
      options: {
        cajaCategories: [],
        showWarning: false,
        loadingAuthUser: false,
        loadingSummary: false,
        isAuthenticated: false,
        advancedOptions: false,
        showFormularioEntrada: true,
        showCotizador: false,
        showPlanVital: false,
        component: 1,
      },
      tarifaPlanVital: 0,
    };

    this.rules = {
      name: {
        required: true,
        alphabetical: (value) => {
          return /^[a-zA-Z áéíóúÁÉÍÓÚñÑ]*$/.test(value) && value.trim() != '';
        }
      },
      email: {
        required: true,
        email: true
      },
      cajaCategory: {
        required: (value) => {
          return this.state.form.caja.value;
        }
      }
    };
    this.subscribedRules = JSON.parse(JSON.stringify(this.rules));
    delete this.subscribedRules.email;
    delete this.subscribedRules.name.required;

    this.saludValidaciones = new SaludValidaciones(this.state.form, this.rules);

    this.userMoreThan60 = null;
    this.advancedOptions = false;

    this.subscribedSaludValidaciones = {
      lessthan60: [],
      morethan60: []
    };
    this.summary = this.state.summary;
    this.categoriaCaja = ""
    this.calculator = this.calculator.bind(this);
    this.updateFormState = this.updateFormState.bind(this);
    this.updateOptionsState = this.updateOptionsState.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.subscribedHandleChange = this.subscribedHandleChange.bind(this);
    this.subscribedHandleSelect = this.subscribedHandleSelect.bind(this);
    this.subscribedHandleBlur = this.subscribedHandleBlur.bind(this);
    this.subscribedHandleSwitch = this.subscribedHandleSwitch.bind(this);
    this.subscribedCleanData = this.subscribedCleanData.bind(this);
    this.subscribedRemove = this.subscribedRemove.bind(this);
    this.subscribedCleanAll = this.subscribedCleanAll.bind(this);
    this.scrollTo = this.scrollTo.bind(this);
    this.getPopover = this.getPopover.bind(this);
    this.showMessages = this.showMessages.bind(this);
    this.updateState = this.updateState.bind(this);
    this.getLogedUserData = this.getLogedUserData.bind(this);
    this.showCotizadorAtCloseModal = this.showCotizadorAtCloseModal.bind(this);
    this.handleComponent = this.handleComponent.bind(this);
    this.showMessagesPlanVital = this.showMessagesPlanVital.bind(this);    
  }

  componentDidMount = () => {
    const options = JSON.parse(JSON.stringify(this.state.options));
    const pnpService = new ServicioPnp();
    pnpService.getList('categoriasCaja', (list) => {
      options.cajaCategories = list;
      this.setState({ options });
    }, null, 'ID', 'CSTituloCategoriaText', 'CSDescripcionNote');
    const tarifaPlanVital = new ServicioProxy('ObtenerTarifaPlanVital');
    tarifaPlanVital.getElements('POST', {}).then(
      (result) => {
        const data = JSON.parse(result);
        this.setState({ tarifaPlanVital: data })
      }
    )
    setTimeout(() => {
      this.isAuthenticated();
    }, 500)
  }

  getLogedUserData(documentType, documentNumber) {
    // requestBody anterior:
    // const requestBody = {
    //   "TipoDocumento": this.state.form.documentType.value,
    //   "NumeroDocumento": this.state.form.documentNumber.value
    // }
    const requestBody = {
      "TipoDocumento": documentType,
      "NumeroDocumento": documentNumber
    }
    const userData = new ServicioProxy('ObtenerDatosUsuarioAutenticadoCotizador');
    userData.getElements('POST', requestBody).then((result) => {
      result = JSON.parse(result);
      this.setState({
        form: {
          ...this.state.form,
          name: { ...this.state.form.name, value: result.NombreCompleto },
          email: { ...this.state.form.email, value: result.Email },
          identificationType: { ...this.state.form.identificationType, value: result.TipoDocumento.Documento, sigla: result.TipoDocumento.Sigla },
          identificationNumber: { ...this.state.form.identificationNumber, value: result.NumeroDocumento },
          phone: { ...this.state.form.phone, value: result.Telefono }
        }
      })

    }).catch(error => {
      this.showMessages();
    });
  }

  showMessages() {
    this.refs.message.handleShow();
    compensar.quitarLoading(".simulation-container")
  }

  showMessagesPlanVital() {
    this.refs.messagePlanvital.handleShow();
  }

  isAuthenticated() {
    if (!compTools.autenticadoWindows() && compTools.estaAutenticado()) {
      const options = JSON.parse(JSON.stringify(this.state.options));
      options.loadingAuthUser = true;
      this.setState({ options });
      const authenticatedUser = compTools.obtenerInformacionUsuario();
      const userDataService = new ServicioProxy('GetSimulacionUsuario?tipoDocumento=' + (authenticatedUser.TipoIdentificacion) + '&numeroDocumento=' + (authenticatedUser.LegalID));
      userDataService.getElements('POST', {}).then((userData) => {
        userData = JSON.parse(userData);
        this.userMoreThan60 = userData.Interesado.MayorEdadDefinida;
        let newState = JSON.parse(JSON.stringify(this.state));
        newState.options.isAuthenticated = true;
        newState.options.loadingAuthUser = false;
        newState.form.lessthan60.value = !userData.Interesado.MayorEdadDefinida ? (newState.form.lessthan60.value + 1) : newState.form.lessthan60.value;
        newState.form.morethan60.value = userData.Interesado.MayorEdadDefinida ? (newState.form.morethan60.value + 1) : newState.form.morethan60.value;
        newState.form.name.value = userData.Interesado.Nombre;
        newState.form.email.value = userData.Interesado.CorreoElectronico ? userData.Interesado.CorreoElectronico.toLowerCase() : '';
        newState.form.caja.value = userData.Interesado.CajaCompensacionCompensar;
        newState.form.cajaCategory.value = userData.Interesado.Categoria.Titulo;
        newState.form.eps.value = userData.Interesado.EPSCompensar;
        newState.form.documentType = { value: userData.Interesado.TipoDeDocumento };
        newState.form.documentNumber = { value: userData.Interesado.NumeroDeDocumento };
        newState.form.age = { value: userData.Interesado.Edad };
        newState.form.gender = { value: userData.Interesado.Genero };
        newState.form.isOlder = { value: userData.Interesado.MayorEdadDefinida };
        newState.form.includeMe = { value: userData.Interesado.AfiliarInteresado, valid: true, error: "" };
        newState.form.relationship = { value: userData.Interesado.Parentesco };
        newState.form.nit = { value: userData.Interesado.NIT };
        userData.BeneficiariosMenores.forEach((subscribed) => {
          let newSubscribed = {
            form: {
              name: { value: subscribed.Nombre },
              caja: { value: subscribed.CajaCompensacionCompensar },
              cajaCategory: { value: subscribed.Categoria.Titulo },
              eps: { value: subscribed.EPSCompensar },
              documentType: { value: subscribed.TipoDeDocumento },
              documentNumber: { value: subscribed.NumeroDeDocumento },
              age: { value: subscribed.Edad },
              gender: { value: subscribed.Genero },
              relationship: { value: subscribed.Parentesco },
              nit: { value: subscribed.NIT },
              email: { value: subscribed.CorreoElectronico }
            }
          };
          newState.subscribed.lessthan60.push(newSubscribed);
          this.subscribedSaludValidaciones['lessthan60'].push(new SaludValidaciones(newSubscribed.form, this.subscribedRules));
          newState.form.lessthan60.value++;
        });
        userData.BeneficiariosMayores.forEach((subscribed) => {
          let newSubscribed = {
            form: {
              name: { value: subscribed.Nombre },
              caja: { value: subscribed.CajaCompensacionCompensar },
              cajaCategory: { value: subscribed.Categoria.Titulo },
              eps: { value: subscribed.EPSCompensar },
              documentType: { value: subscribed.TipoDeDocumento },
              documentNumber: { value: subscribed.NumeroDeDocumento },
              age: { value: subscribed.Edad },
              gender: { value: subscribed.Genero },
              relationship: { value: subscribed.Parentesco },
              nit: { value: subscribed.NIT },
              email: { value: subscribed.CorreoElectronico }
            }
          };
          newState.subscribed.morethan60.push(newSubscribed);
          newState.form.morethan60.value++;
          this.subscribedSaludValidaciones['morethan60'].push(new SaludValidaciones(newSubscribed.form, this.subscribedRules));
        });
        //if(userData.BeneficiariosMenores.length > 0 || userData.BeneficiariosMayores.length > 0) {
        newState.options.advancedOptions = true;
        //} 
        if (this.state.options.component !== 1) {
          newState.summary.monthlyFare = userData.Simulacion.PrecioMensualDesde;
          newState.summary.epsDiscount = userData.Simulacion.DescuentoEps;
          newState.summary.cajaDiscount = userData.Simulacion.DescuentoCajaCompensacion;
          newState.summary.iva = userData.Simulacion.IVA;
          newState.summary.lessthan60quantity = userData.Simulacion.UsuariosMenorEdadDefinida.CantidadUsuarios;
          newState.summary.lessthan60total = userData.Simulacion.UsuariosMenorEdadDefinida.ValorTotal;
          newState.summary.morethan60quantity = userData.Simulacion.UsuariosMayorEdadDefinida.CantidadUsuarios;
          newState.summary.morethan60total = userData.Simulacion.UsuariosMayorEdadDefinida.ValorTotal;
          newState.summary.totalQuantity = userData.Simulacion.UsuariosTotal.CantidadUsuarios;
          newState.summary.total = userData.Simulacion.UsuariosTotal.ValorTotal;
        }
        this.setState(newState);
        this.getLogedUserData(authenticatedUser.TipoIdentificacion, authenticatedUser.LegalID);
        this.getDataUserPlanVital()
        this.categoriaCaja = userData.Interesado.Categoria.Titulo;
      }).catch(error => {
        console.log("error", error);
        this.showMessages();
      });
    }
  }

  getDataUserPlanVital() {
    const authenticatedUser = compTools.obtenerInformacionUsuario();
    let body = {
      "TipoDocumento": authenticatedUser.TipoIdentificacion,
      "NumeroDocumento": authenticatedUser.LegalID,
      "CategoriasPlanVital": "A,B",
      "EstadosVinculacion": "AF,CI,SU,MO"
    }
    const dataUserPlanVital = new ServicioProxy('ObtenerDatosAfiliacionPlanVital');
    dataUserPlanVital.getElements('POST', body).then(
      (result) => {
        const data = JSON.parse(result);
        // data.ObtenerDatosAfiliacionPlanVitalResult.DatosInteresado.PuedeContinuarAfiliacion = true
        // data.ObtenerDatosAfiliacionPlanVitalResult.DatosBeneficiariosMenores.Beneficiarios = []
        this.setState({ dataUserPlanVital: data }, () => this.updateSubscriberPlanVital())
        sessionStorage.setItem('planVital_cajaCetegory', data.ObtenerDatosAfiliacionPlanVitalResult.DatosInteresado.CategoriaCaja);

      }
    )
  }

  updateSubscriberPlanVital() {
    let subscribed = this.state.subscribed;
    subscribed.lessthan60.map(item => {
      this.state.dataUserPlanVital.ObtenerDatosAfiliacionPlanVitalResult.DatosBeneficiariosMenores.Beneficiarios.map(afiliado => {
        if (item.form.documentNumber.value === afiliado.NumeroDocumento) {
          item.form.cajaCategory.valid = afiliado.CategoriaCaja
          item.form.caja.value = afiliado.TieneCajaCompensacion
          item.form.eps.value = afiliado.TieneEpsCompensar
        }
      })
    })
    let lessthan60 = { ...this.state.subscribed }
    lessthan60.lessthan60 = subscribed.lessthan60
    this.setState({ subscribed: lessthan60 })
  }

  calculator(type, operation, callback) {
    let newState = JSON.parse(JSON.stringify(this.state));
    let sum = this.state.form['lessthan60'].value + this.state.form['morethan60'].value;
    if ((this.state.form[type].value > 0 && operation == 'remove') || (sum < 20 && operation == 'add')) {
      if (operation == 'remove') {
        newState.form[type].value--;
        this.removeSubscribed(newState.subscribed[type], type);
      } else if (operation == 'add') {
        newState.form[type].value++;
        this.addSubscribed(newState.subscribed[type], type);
      }
      newState.options.showWarning = false;
      this.setState(newState, () => {
        this.calculateRequest();
        if (callback) callback();
      });
    } else if (operation == 'add' && sum == 20 && !this.state.options.showWarning) {
      newState.options.showWarning = true;
      this.setState(newState);
    }
    if (newState.form.lessthan60.value + newState.form.morethan60.value == 0) newState.options.advancedOptions = false;
  }

  addSubscribed(subscribedList, type) {
    let newSubscribed = {
      form: {
        name: { value: '' },
        caja: { value: this.state.options.component === 3 ? true : false },
        cajaCategory: { value: '' },
        eps: { value: this.state.options.component === 3 ? true : false },
        isValid: true
      }
    };
    subscribedList.push(newSubscribed);
    this.subscribedSaludValidaciones[type].push(new SaludValidaciones(newSubscribed.form, this.subscribedRules));
  }

  removeSubscribed(subscribedList, type) {
    subscribedList.splice(subscribedList.length - 1, 1);
    this.subscribedSaludValidaciones[type].splice(this.subscribedSaludValidaciones[type].length - 1, 1);
  }

  updateFormState(newForm, calculateRequest) {
    if (!calculateRequest) {
      this.setState({ form: newForm });
    } else if (calculateRequest) {
      this.setState({ form: newForm }, () => {
        this.calculateRequest();
      });
    }
    this.categoriaCaja = newForm.cajaCategory.value
  }

  updateOptionsState(options, calculateRequest) {
    if (!calculateRequest) {
      this.setState({ options });
    } else if (calculateRequest) {
      this.setState({ options }, () => {
        this.calculateRequest();
      });
    }
  }

  handleSubmit(callback) {
    let currentForm = JSON.parse(JSON.stringify(this.state.form));
    this.saludValidaciones.validateForm(currentForm);
    let allSubscribedValids = true;
    for (let type in this.subscribedSaludValidaciones) {
      this.subscribedSaludValidaciones[type].forEach((subscribedValidation, index) => {
        subscribedValidation.validateForm(this.state.subscribed[type][index].form);
        if (!this.state.subscribed[type][index].form.isValid) allSubscribedValids = false;
      });
    }
    this.setState({ form: currentForm }, () => {
      if (this.state.form.isValid && allSubscribedValids) {
        callback();
      }
    });
  }

  subscribedCleanAll(event) {
    event.preventDefault();
    this.subscribedSaludValidaciones.lessthan60 = [];
    this.subscribedSaludValidaciones.morethan60 = [];
    let currentState = JSON.parse(JSON.stringify(this.state));
    currentState.form.lessthan60.value = 0;
    currentState.form.morethan60.value = 0;
    // currentState.form.name.value = '';
    // currentState.form.email.value = '';
    // currentState.form.caja.value = false;
    // currentState.form.cajaCategory.value = '';
    // currentState.form.eps.value = false;
    // currentState.form.includeMe.value = false;
    // this.saludValidaciones.resetForm(currentState.form);
    currentState.subscribed.lessthan60 = [];
    currentState.subscribed.morethan60 = [];
    currentState.options.advancedOptions = false;
    this.setState(currentState, () => {
      this.calculateRequest();
    });
  }

  subscribedCleanData(indexOfSubscribed, type, event) {
    event.preventDefault();
    let currentSubscribed = JSON.parse(JSON.stringify(this.state.subscribed));
    currentSubscribed[type][indexOfSubscribed].form = {
      name: { value: '' },
      caja: { value: this.state.options.component === 3 ? true : false },
      cajaCategory: { value: '' },
      eps: { value: this.state.options.component === 3 ? true : false }
    };
    this.subscribedSaludValidaciones[type][indexOfSubscribed].resetForm(currentSubscribed[type][indexOfSubscribed].form);
    this.setState({ form: this.state.form, subscribed: currentSubscribed }, () => {
      this.calculateRequest();
    });
  }

  subscribedRemove(indexOfSubscribed, type, callback) {
    let currentState = JSON.parse(JSON.stringify(this.state));
    currentState.form[type].value--;
    currentState.subscribed[type].splice(indexOfSubscribed, 1);
    this.subscribedSaludValidaciones[type].splice(indexOfSubscribed, 1);
    if (currentState.form.lessthan60.value + currentState.form.morethan60.value == 0) currentState.options.advancedOptions = false;
    this.setState(currentState, () => {
      this.calculateRequest();
      if (callback) callback();
    });
  }

  removeNonLetters(string) {
    const regex = /[^a-zA-Z\s]/gi;
    return string.replace(regex, '');
  }

  subscribedHandleChange(indexOfSubscribed, type, event) {
    let currentSubscribed = JSON.parse(JSON.stringify(this.state.subscribed));
    currentSubscribed[type][indexOfSubscribed].form[event.target.id].value = event.target.value;
    if (event.target.id === "name") {
      currentSubscribed[type][indexOfSubscribed].form[event.target.id].value = this.removeNonLetters(event.target.value);
    }
    this.setState({ form: this.state.form, subscribed: currentSubscribed });
  }

  subscribedHandleSelect(indexOfSubscribed, field, type, value) {
    let currentSubscribed = JSON.parse(JSON.stringify(this.state.subscribed));
    currentSubscribed[type][indexOfSubscribed].form[field].value = value;
    this.setState({ form: this.state.form, subscribed: currentSubscribed }, () => {
      this.calculateRequest();
    });
  }

  subscribedHandleBlur(indexOfSubscribed, type, event) {
    let currentSubscribed = JSON.parse(JSON.stringify(this.state.subscribed));
    //let currentOptions = JSON.parse(JSON.stringify(this.state.options));
    let element = event.target;
    this.saludValidaciones.validateField(element, currentSubscribed[type][indexOfSubscribed].form);
    /*let lastAdvancedOptions = currentOptions.advancedOptions;
    if (element.value) currentOptions.advancedOptions = true;*/
    this.setState({ form: this.state.form, subscribed: currentSubscribed/*, options: currentOptions*/ }, () => {
      //(!lastAdvancedOptions && currentOptions.advancedOptions) && this.calculateRequest();
    });
  }

  subscribedHandleSwitch(indexOfSubscribed, value, field, type) {
    let currentSubscribed = JSON.parse(JSON.stringify(this.state.subscribed));
    //let currentOptions = JSON.parse(JSON.stringify(this.state.options));
    currentSubscribed[type][indexOfSubscribed].form[field].value = value;
    //currentOptions.advancedOptions = true;
    if (this.state.options.component !== 3) {
      this.setState({ form: this.state.form, subscribed: currentSubscribed/*, options: currentOptions*/ }, () => {
        this.calculateRequest();
      });
    }
  }

  getPopover(key) {
    return (
      <Popover title="">
        <div dangerouslySetInnerHTML={{ __html: this.props.popovers[key].description }} />
      </Popover>
    )
  }

  scrollTo(elementId, event) {
    event.preventDefault();
    let windowWidth = $(window).width();
    $('html, body').animate({
      scrollTop: $(elementId).offset().top - $('header').height()
    }, 'fast');
  }

  calculateRequest() {
    //if (!this.state.form.caja.value || (this.state.form.caja.value && this.state.form.cajaCategory.value)) {
    if (this.state.options.component === 3) {
      let subscribedQuantity = this.state.subscribed.lessthan60.length
      let cantidadTotal = this.state.form.includeMe.value ? (subscribedQuantity + 1) : subscribedQuantity
      let valorTotal = this.state.form.includeMe.value ? (this.state.tarifaPlanVital * (subscribedQuantity + 1)) : this.state.tarifaPlanVital * subscribedQuantity
      this.setState({
        summary: {
          monthlyFare: this.state.tarifaPlanVital,
          lessthan60quantity: this.state.subscribed.lessthan60.length,
          lessthan60total: this.state.tarifaPlanVital * this.state.subscribed.lessthan60.length,
          totalQuantity: cantidadTotal,
          total: valorTotal,
          morethan60total: 0,
          morethan60quantity: 0,
          epsDiscount: 0,
          cajaDiscount: 0,
        }
      });
    } else {
      const calculateRequestBody = {
        Interesado: {
          MayorEdadDefinida: this.userMoreThan60,
          NumeroDeDocumento: null,
          TipoDeDocumento: null,
          Nombre: this.state.form.name.value,
          CorreoElectronico: this.state.form.email.value,
          CajaCompensacionCompensar: this.state.form.caja.value && this.state.form.cajaCategory.value ? true : false,
          Categoria: this.state.form.caja.value && this.state.form.cajaCategory.value ? {
            Titulo: this.state.form.cajaCategory.value,
            TituloConsorcio: null,
            Descripcion: null,
            Id: 1,
            Title: this.state.form.cajaCategory.value
          } : null,
          EPSCompensar: this.state.form.eps.value,
          AfiliarInteresado: this.userMoreThan60 !== null ? this.state.form.includeMe.value : null
        },
        BeneficiariosMayores: this.state.subscribed.morethan60.reduce((filtered, subscribed) => {
          //if (!subscribed.form.caja.value || (subscribed.form.caja.value && subscribed.form.cajaCategory.value)) {
          filtered.push({
            MayorEdadDefinida: true,
            NumeroDeDocumento: null,
            TipoDeDocumento: null,
            Nombre: subscribed.form.name.value,
            CorreoElectronico: null,
            CajaCompensacionCompensar: (this.state.options.isAuthenticated || this.state.options.advancedOptions) ? (subscribed.form.caja.value && subscribed.form.cajaCategory.value ? true : false) : (this.state.form.caja.value && this.state.form.cajaCategory.value ? true : false),
            Categoria: (this.state.options.isAuthenticated || this.state.options.advancedOptions) ? (subscribed.form.caja.value && subscribed.form.cajaCategory.value ? {
              Titulo: subscribed.form.cajaCategory.value,
              TituloConsorcio: null,
              Descripcion: null,
              Id: 1,
              Title: subscribed.form.cajaCategory.value
            } : null) : (this.state.form.caja.value && this.state.form.cajaCategory.value ? {
              Titulo: this.state.form.cajaCategory.value,
              TituloConsorcio: null,
              Descripcion: null,
              Id: 1,
              Title: this.state.form.cajaCategory.value
            } : null),
            EPSCompensar: (this.state.options.isAuthenticated || this.state.options.advancedOptions) ? subscribed.form.eps.value : this.state.form.eps.value
          });
          //}
          return filtered;
        }, []),
        // BeneficiariosMenores: initialBeneficiarioMayor ? initialBeneficiarioMayor : this.state.subscribed.lessthan60.reduce((filtered, subscribed) => {
        BeneficiariosMenores: this.state.subscribed.lessthan60.reduce((filtered, subscribed) => {
          //if (!subscribed.form.caja.value || (subscribed.form.caja.value && subscribed.form.cajaCategory.value)) {
          filtered.push({
            MayorEdadDefinida: false,
            NumeroDeDocumento: null,
            TipoDeDocumento: null,
            Nombre: subscribed.form.name.value,
            CorreoElectronico: null,
            CajaCompensacionCompensar: (this.state.options.isAuthenticated || this.state.options.advancedOptions) ? (subscribed.form.caja.value && subscribed.form.cajaCategory.value ? true : false) : (this.state.form.caja.value && this.state.form.cajaCategory.value ? true : false),
            Categoria: (this.state.options.isAuthenticated || this.state.options.advancedOptions) ? (subscribed.form.caja.value && subscribed.form.cajaCategory.value ? {
              Titulo: subscribed.form.cajaCategory.value,
              TituloConsorcio: null,
              Descripcion: null,
              Id: 1,
              Title: subscribed.form.cajaCategory.value
            } : null) : (this.state.form.caja.value && this.state.form.cajaCategory.value ? {
              Titulo: this.state.form.cajaCategory.value,
              TituloConsorcio: null,
              Descripcion: null,
              Id: 1,
              Title: this.state.form.cajaCategory.value
            } : null),
            EPSCompensar: (this.state.options.isAuthenticated || this.state.options.advancedOptions) ? subscribed.form.eps.value : this.state.form.eps.value
          });
          //}
          return filtered;
        }, [])
      };
      if (calculateRequestBody.BeneficiariosMayores.length == 0) calculateRequestBody.BeneficiariosMayores = null;
      if (calculateRequestBody.BeneficiariosMenores.length == 0) calculateRequestBody.BeneficiariosMenores = null;
      const options = JSON.parse(JSON.stringify(this.state.options));
      options.loadingSummary = true;
      this.setState({ options });
      const calcularTarifaService = new ServicioProxy('CalcularTarifa');
      calcularTarifaService.getElements('POST', calculateRequestBody).then((result) => {
        result = JSON.parse(result);
        options.loadingSummary = false;
        this.setState({
          summary: {
            monthlyFare: result.PrecioMensualDesde,
            epsDiscount: result.DescuentoEps,
            cajaDiscount: result.DescuentoCajaCompensacion,
            lessthan60quantity: result.UsuariosMenorEdadDefinida.CantidadUsuarios,
            lessthan60total: result.UsuariosMenorEdadDefinida.ValorTotal,
            morethan60quantity: result.UsuariosMayorEdadDefinida.CantidadUsuarios,
            morethan60total: result.UsuariosMayorEdadDefinida.ValorTotal,
            totalQuantity: result.UsuariosTotal.CantidadUsuarios,
            total: result.UsuariosTotal.ValorTotal
          }, options
        });

      }).catch(error => {
        this.showMessages();
      });
    }
    // }
  }

  updateState(formState, component) {
    this.setState({ options: { ...this.state.options, showCotizador: true, component } });
    let form = this.state.form
    form.name.value = formState.fullName.value
    form.email.value = formState.email.value
    form.identificationType.value = formState.identificationType.value
    form.identificationType.sigla = formState.identificationType.sigla
    form.identificationNumber.value = formState.identificationNumber.value
    form.phone.value = formState.phone.value
    form.confirmPersonalData = formState.confirmPersonalData
    form.confirmEmailMessage = formState.confirmEmailMessage
    form.confirmTextMessage = formState.confirmTextMessage
    form.cajaCategory.value = form.cajaCategory.value

    this.setState({ form:form }, () => this.guardarCotizacion(component === 3 ? true : false))
    // this.setState({
    //   form: {
    //     ...this.state.form,
    //     name: { value: formState.fullName.value },
    //     email: { ...this.state.form.email, value: formState.email.value },
    //     identificationType: { ...this.state.form.identificationType, value: formState.identificationType.value, sigla: formState.identificationType.sigla },
    //     identificationNumber: { ...this.state.form.identificationNumber, value: formState.identificationNumber.value },
    //     phone: { ...this.state.form.phone, value: formState.phone.value },
    //     confirmPersonalData: formState.confirmPersonalData,
    //     confirmEmailMessage: formState.confirmEmailMessage,
    //     confirmTextMessage: formState.confirmTextMessage
    //   }
    // }, () => {
    //   this.guardarCotizacion(this.state.options.component === 3 ? true : false)
    // })
  }

  showCotizadorAtCloseModal(event) {
    let reset = { ...this.state.form }
    reset.name.value = "";
    reset.email.value = "";
    reset.identificationType.value = "Seleccione un documento";
    reset.identificationNumber.value = "";
    reset.phone.value = "";
    // this.setState({ options: { ...this.state.options, showCotizador: false } });
    this.setState({ form: reset, options: { ...this.state.options, component: 1, showCotizador: false } },
      () =>
        this.subscribedCleanAll(event));
  }

  guardarCotizacion(planVital) {
    const data = {
      "NombreCompleto": this.state.form.name.value,
      "TipoDocumento": this.state.form.identificationType.sigla,
      "NumeroDocumento": this.state.form.identificationNumber.value,
      "Telefono": this.state.form.phone.value,
      "Email": this.state.form.email.value,
      "AutorizaTratamientoDatos": this.state.form.confirmPersonalData.value,
      "AceptaRecibirInformacion": this.state.form.confirmEmailMessage.value,
      "AceptaMensajes": this.state.form.confirmTextMessage.value,
      "EsPlanVital": planVital
    }
    const guadarCotizacion = new ServicioProxy('GuardarCotizacion');
    if (this.state.form.confirmPersonalData) {
      guadarCotizacion.getElements('POST', data).then(
        (result) => {
          const data = JSON.parse(result);
          sessionStorage.setItem('idCotizacion', data.IdCotizacion)
        }
      )
    }
  }

  formularioEntrada(showModalPlanVital) {
    return (
      <FormularioEntrada
        configurations={this.props.configurations}
        updateState={this.updateState.bind(this)}
        form={this.state.form}
        isAuthenticated={this.state.options.isAuthenticated}
        planVital={this.state.options.component === 3 ? true : false}
        showModalPlanVital={showModalPlanVital}
      />
    )
  }

  cotizarFormulario(planvital) {
    let form = this.state.form
    if (planvital && compTools.estaAutenticado()) {
      form.cajaCategory.value = this.categoriaCaja == form.cajaCategory.value ? form.cajaCategory.value : this.categoriaCaja
    }
    return (
      <div className={"fadeIn"}>
        <CotizarFormulario className="reference_element"
          configurations={this.props.configurations}
          popovers={this.props.popovers}
          getPopover={this.getPopover}
          saludValidaciones={this.saludValidaciones}
          updateFormState={this.updateFormState}
          updateOptionsState={this.updateOptionsState}
          subscribedHandleChange={this.subscribedHandleChange}
          subscribedHandleBlur={this.subscribedHandleBlur}
          subscribedHandleSwitch={this.subscribedHandleSwitch}
          subscribedHandleSelect={this.subscribedHandleSelect}
          subscribedCleanAll={this.subscribedCleanAll}
          subscribedCleanData={this.subscribedCleanData}
          subscribedRemove={this.subscribedRemove}
          isAuthenticated={this.state.options.isAuthenticated}
          form={planvital && compTools.estaAutenticado() ? form : this.state.form}
          subscribed={this.state.subscribed}
          calculator={this.calculator}
          options={this.state.options}
          calculateRequest={this.calculateRequest}
          planvital={planvital}
        // componentMounted={this.state.options.component}
        />
      </div>
    )
  }

  handleComponent() {
    let component = null;
    let userPlanVital = this.state.dataUserPlanVital ? this.state.dataUserPlanVital.ObtenerDatosAfiliacionPlanVitalResult : null
    if (this.state.options.component === 1) {
      component = this.formularioEntrada();
    } else if (this.state.options.component === 2) {
      component = this.cotizarFormulario();
    } else if (this.state.options.component === 3) {
      if (!compTools.autenticadoWindows() && compTools.estaAutenticado()) {
        if (userPlanVital.DatosInteresado.PuedeContinuarAfiliacion) {
          let puedeCotizarPlanVital = userPlanVital.DatosBeneficiariosMenores.Beneficiarios.filter(item => item.PuedeContinuarAfiliacion == false)
          let filterByCathegory = this.state.form.cajaCategory.value = 'A' || 'B'
          if (puedeCotizarPlanVital.length === 0 && filterByCathegory) {
            component = this.cotizarFormulario(true);
          } else {
            component = this.formularioEntrada(false);
            this.setState({ options: { ...this.state.options, component: 1 } });
            this.showMessagesPlanVital();
          }
        } else {
          component = this.formularioEntrada(false);
          this.setState({ options: { ...this.state.options, component: 1 } });
          this.showMessagesPlanVital();
        }
      } else {
        component = this.cotizarFormulario(true);
      }
      // component = this.cotizarFormulario(true);
    }
    return component
  }


  render() {
    return (
      <div className="cotizar">
        <h1>Cotiza tu Plan Complementario y Disfruta tu Salud</h1>
        <p className="hidden-xs">{this.props.configurations['TextoIntroductorio']}</p>
        <div id="simulation-top" className="row simulation-top">
          <div className="col-sm-8 text-center">
            <p className="cotizar-note">{this.props.configurations['ConoceLosBeneficiosDelPlanComplementario']}</p>
            {this.props.configurations['ConoceLosBeneficiosDelPlanComplementarioIcono'] &&
              <a href="#beneficios" onClick={(event) => this.scrollTo('#beneficios', event)}><img src={_spPageContextInfo.siteAbsoluteUrl + '/Style Library/Images/' + this.props.configurations['ConoceLosBeneficiosDelPlanComplementarioIcono']} className="mb-10" /></a>
            }
          </div>
        </div>
        <div className="row simulation-container" id="simulation-container" style={{ position: 'relative' }}>

          <div className={'loadingWraper loadingWraper--' + (this.state.options.loadingAuthUser ? 'visible' : 'hidden')}><div className="compensarLoading"><span>cargando...</span></div></div>

          <div className="col-sm-12 col-md-8 panel-detail-left" id="box-cotizar">
            {this.handleComponent()}
          </div>

          <div className="col-sm-12 col-md-4 panel-left-summary" id="panel-left-summary">
            <CotizarResumen
              className="container-summary"
              disabled={this.state.options.component === 1 ? false : this.state.options.showCotizador}
              configurations={this.props.configurations}
              form={this.state.form}
              subscribed={this.state.subscribed}
              summary={this.state.options.component === 1 ? this.summary : this.state.summary}
              options={this.state.options}
              loadingSummary={this.state.options.loadingSummary}
              startShoppingProperties={this.props.startShoppingProperties}
              handleSubmit={this.handleSubmit}
              showCotizador={this.showCotizadorAtCloseModal}
              planvital={this.state.options.component === 3 ? true : false}
              precio={this.state.tarifaPlanVital}
            />
          </div>

        </div>
        {
          this.props.configurations['noContinuaPlanVital'] || 
          <Mensajes ref="messagePlanvital" msg={this.props.configurations['noContinuaPlanVital']} />
        }
        {
          this.props.configurations['MensajeErrorDeServicios'] ||
          <Mensajes ref="message" msg={this.props.configurations['MensajeErrorDeServicios']} />
        }
      </div>
    );
  }
}

/******************** BUILD ********************/
let Popover = ReactBootstrap.Popover;
/******************** BUILD ********************/
